/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UnFormalizedZipRequestDto = {
    /**
     * ID двигателя
     */
    engineId: number;
    /**
     * Описание запроса
     */
    description: string;
    /**
     * UUID документа
     */
    docUrlUuids?: Array<string>;
    /**
     * Статус запроса
     */
    status: UnFormalizedZipRequestDto.status;
};

export namespace UnFormalizedZipRequestDto {

    /**
     * Статус запроса
     */
    export enum status {
        NEW = 'NEW',
        COMPLETED = 'COMPLETED',
    }


}

